import {ReactNode} from 'react';
import {TFunction} from 'i18next';
import * as css from './MobileSummary.css';
import {COLORS} from '../../colors';
import {TTimetableSales} from '../../../../../../../redux/realtime/realtime.type';

type TSummary = TTimetableSales['summary'];

function MCard({title, total, value, children}: {title: string; total: string; value: string; children: ReactNode}) {
    return (
        <css.mCard>
            <css.mTitle>{title}</css.mTitle>
            <css.mTotalRow><css.mBig>{value}</css.mBig><css.mTotal>{total}</css.mTotal></css.mTotalRow>
            {children}
        </css.mCard>
    );
}

function MobileSummary({capacity, lectures, revenue, money, t}: TSummary & {money: (v: number) => string; t: TFunction}) {
    return (
        <css.summaryColumn>
            <MCard title={t('lectures')} total={t('totalLectures', {count: lectures.total})} value={`${lectures.percent}%`}>
                <css.mRows>
                    <css.mRow><css.mLabel><css.dot $c={COLORS.active} />{t('activeLecturesCount', {count: lectures.active})}</css.mLabel></css.mRow>
                    <css.mRow><css.mLabel><css.dot $c={COLORS.off} />{t('offLecturesCount', {count: lectures.off})}</css.mLabel></css.mRow>
                </css.mRows>
            </MCard>

            <MCard title={t('capacityUtilization')} total={t('totalSeats', {count: capacity.total})} value={`${capacity.percent}%`}>
                <css.mRow><css.mLabel>{t('takenSeatsCount', {count: capacity.taken})}</css.mLabel>{t('freeSeatsCount', {count: capacity.free})}</css.mRow>
                <css.mBar><css.mBarFill style={{width: `${Math.min(capacity.percent, 100)}%`}} /></css.mBar>
            </MCard>

            <MCard title={t('combinedRevenue')} total={t('total')} value={money(revenue.total)}>
                <css.mRows>
                    <css.mRow><css.mLabel><css.dot $c={COLORS.base} />{t('baseTickets')}</css.mLabel>{money(revenue.baseTickets.total)}</css.mRow>
                    <css.mRow><css.mLabel><css.dot $c={COLORS.casual} />{t('singleLectureTickets')}</css.mLabel>{money(revenue.singleLecture.total)}</css.mRow>
                    <css.mRow><css.mLabel><css.dot $c={COLORS.extras} />{t('extrasAndMeals')}</css.mLabel>{money(revenue.extras.total)}</css.mRow>
                </css.mRows>
            </MCard>
        </css.summaryColumn>
    );
}
export default MobileSummary;
